export default __webpack_public_path__ + "static/media/bangle-size-guide.65fadfb2.jpg";